var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"notification",staticClass:"notification",class:[_vm.type,_vm.open],style:({top: _vm.top})},[_vm._v(" "+_vm._s(_vm.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }